import { Component, OnInit } from '@angular/core';
import {ConfigService} from '../../../../../core/services/config.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BrandService} from '../brand.service';
import {NotificationService} from '../../../../../core/services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RxComponent} from '../../../../../core/components/common/rx.component';

@Component({
  selector: 'itpx-brand-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class BrandEditComponent extends RxComponent implements OnInit {

    private id: string;
    private details: any;
    private bucket: any;
    private component: string = 'content-uploader';
    private brandImgPath: string;
    brandingForm: FormGroup;

    constructor(
        private configService: ConfigService,
        private service: BrandService,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit() {
        this.bucket = this.configService.get('aws').productUploadBrandingBucket;
        this.brandingForm = this.fb.group({
            type: [null],
            name: [null, Validators.required],
            description: [null],
            image: [null]
        });
        this.route.params
            .subscribe(params => {
                this.id = params['id'];
                this.service.details(this.id)
                    .subscribe(body => {
                        this.details = body.data;
                        if(this.details) {
                            this.brandingForm.patchValue({
                                type: this.details.type,
                                name: this.details.name,
                                description: this.details.description,
                                image: this.details.image
                            })
                        }
                        if(this.details.image) {
                            this.brandImgPath = this.details.image;
                        }
                    })
            })
    }
    private onSaveImg(e: any) {
        this.brandingForm.patchValue({
            image: e.data.path
        })
    }

    onSubmitBrandingForm() {
        let payload = this.brandingForm.getRawValue();
        payload['id'] = this.id;
        this.service.editBrand(payload)
            .bindToLifecycle(this)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully edited a brand', 'Success');
                    this.router.navigate(['/agora/product-data/brands']);
                },
                error => {}
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/brands/edit/edit.component.ts